import { allowListed } from '@comicrelief/component-library';

// Returns true if a url appears to be 'internal' to Comic Relief's websites (even if it has
//  a different subdomain e.g. donation.) or the current page.
const isInternalUrl = targetUrl => allowListed(targetUrl)
  || targetUrl.charAt(0) === '/'
  || targetUrl.charAt(0) === '#';

export default isInternalUrl;
